import React from 'react'
import { ArticleContainer, ArticleContent, ArticleSection, ArticleText, ArticleTitle, BannerContainer, ContentContainer, OptionsIcon } from './styled'
import { parseCustomFieldHtml, parseStrapiImage } from 'utils'
import { Icon } from 'ui/styled'
import FileCard from 'components/Cards/File'
import ExternalResourceLink from 'components/ExternalResourceLink'

export default function Article({ course }) {
  const parsedContent = parseCustomFieldHtml(course?.content)

  const isImage = course?.cover || course?.image?.url

  return (
    <>
      <ArticleContainer>
        {!isImage ? null : <BannerContainer bgImage={course?.image?.url ? parseStrapiImage(course?.image?.url) : course?.cover} />}
        <ArticleSection>
          <ArticleContent>
            <OptionsIcon><Icon icon="article" /></OptionsIcon>
            <ArticleTitle>{course?.title}</ArticleTitle>
          </ArticleContent>
          <ContentContainer>

            <ArticleText dangerouslySetInnerHTML={parsedContent} />
            {!course?.file ? null : <FileCard file={course} />}
            <ExternalResourceLink course={course} />
          </ContentContainer>

        </ArticleSection>
      </ArticleContainer>
    </>
  )
}
